import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {InjectionToken, ModuleWithProviders, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppComponent} from './app.component';
import {SharedDirectives} from './directives';
import {SharedPipes} from './pipes';
import {SharedServices} from './services';
import {SharedModals} from './modals';
import {OverlayModule} from '@angular/cdk/overlay';
import {RouterModule} from '@angular/router';
import {SharedComponents} from './components';
import {ToastrModule} from 'ngx-toastr';
import {CommonConfig} from './configs/common.config';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedInterceptors} from './http-interceptors';
import {LoaderBlackListToken} from '@ui-app/http-interceptors/http-loader.interceptor';
import {Observable} from 'rxjs';
import {ErrorBlackListToken} from '@shared-models/common.models';
import {ModalModule} from 'ngx-bootstrap/modal';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {MatMenuModule} from '@angular/material/menu';

export const USER_DATA_SERVICE = new InjectionToken('User data service token');

/*export function actionsFactory(actionsService: any): any {
    return actionsService;
}*/

export interface UserDataServiceUI {
    getUserData(): Observable<any>;
}

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule
    ],
    bootstrap: [AppComponent],
    declarations: []
})
export class AppModule {
}

@NgModule({
    declarations: [
        AppComponent,
        ...SharedComponents,
        ...SharedDirectives,
        ...SharedPipes,
        ...SharedModals
    ],
    exports: [
        ...SharedComponents,
        ...SharedDirectives,
        ...SharedPipes,
        ...SharedModals,
    ],
    imports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        OverlayModule,
        ModalModule.forRoot(),
        BsDatepickerModule.forRoot(),
        TooltipModule.forRoot(),
        RouterModule,
        ToastrModule.forRoot(CommonConfig.getToastrConfig()),
        ReactiveFormsModule,
        BsDropdownModule.forRoot(),
        PaginationModule.forRoot(),
        MatMenuModule,
    ],
    providers: [
        {
            provide: LoaderBlackListToken,
            useValue: []
        },
        {
            provide: ErrorBlackListToken,
            useValue: []
        }
    ]
})
export class UIComponentsModule {
    static forRoot(): ModuleWithProviders<UIComponentsModule> {
        return {
            ngModule: UIComponentsModule,
            providers: [
                SharedServices,
                SharedInterceptors,
                /*  {
                      provide: UserDataServiceUI,
                      useFactory: actionsFactory,
                      deps: [TOKEN],
                  }*/
            ],
        };
    }
}
